export const DEFAULT_STORAGE_PROVIDER = "civic-s3";
